import React from 'react';
import style from './style.module.scss';

const MiaxLogo: React.FC<{ height?: number | string; className?: string }> = ({ height = 32, className }) => (
  <img
    src='/img/miax-logo.svg'
    alt='MIAX Logo'
    className={`${style['logo-img']} ${className || ''}`.trim()}
    style={height ? { height } : undefined}
    data-testid='miax-logo'
  />
);

export default MiaxLogo;
